import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Button from "@material-ui/core/Button";
import AutoForm from "react-auto-form";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

//import { ToastContainer, toast } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//import { greenValue, orangeValue, redValue } from "../components/Enums.js";

export class E_Mr extends Component {
    //constructor(props) {
    //    super(props);
    //    this.state = {
    //        lastOnChange: null,
    //        lastOnSubmit: null,
    //        trim: true,
    //        trimOnSubmit: false
    //    };
    //}

    //_onChange = (e, name, data, change) => {
    //    console.log(data);
    //    this.setState({ lastOnChange: { name, data, change } });
    //};

    //_onSubmit = (e, data) => {
    //    console.log("submit");
    //    console.log(data);
    //    this.setState({ lastOnSubmit: { data } });
    //    e.preventDefault();
    //};

    //_onOptionsChange = (e, name, data, change) => {
    //    console.log(data);
    //    this.setState(change);
    //};

    //render() {
    //    //let { lastOnChange, lastOnSubmit, trim, trimOnSubmit } = this.state;
    //    let { trim, trimOnSubmit } = this.state;

    constructor(props) {
        super(props);
        this.state = {
            missionId: props.propMissionId,
            lastOnChange: null,
            lastOnSubmit: null,
            trim: false,
            trimOnSubmit: false,
            pageLoadData: {},
            templateId: props.propTemplateId,
            countConclusions: 1,
            countLessonsLearnt: 1,
        };
    }

    _onChange = (e, name, data, change) => {
        console.log(data)

        var pageLoadDataChange = this.state.pageLoadData;
        pageLoadDataChange[name] = data;

        this.setState({
            lastOnChange: { name, data, change },
            pageLoadData: pageLoadDataChange
        });

    }

    _onSubmit = (e, data) => {
        console.log("submit");
        this.setState({ lastOnSubmit: { data } });

        let dataToSubmit = data;
        dataToSubmit["missionId"] = this.state.missionId;
        dataToSubmit["templateId"] = this.state.templateId;
        dataToSubmit["countConclusions"] = this.state.countConclusions;
        dataToSubmit["countLessonsLearnt"] = this.state.countLessonsLearnt;
        console.log(dataToSubmit);

        this.props.propUpdatePageLoadData(dataToSubmit);

        fetch(global.variables.API_TEMPLATEFILLER_FILLANSWERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(dataToSubmit)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            });

        e.preventDefault();
    }

    _onOptionsChange = (e, name, data, change) => {
        console.log(data);
        this.setState(change);
    };

    async componentDidMount() {
        await fetch(global.variables.API_TEMPLATEFILLER_GETANSWERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                operation: "GetExpostMq",
                missionId: this.state.missionId,
                templateId: this.state.templateId
            })
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.saveddata.length > 0) {
                    this.setState({ pageLoadData: JSON.parse(result.saveddata[0].TemplateAnswers) });

                    if (JSON.parse(result.saveddata[0].TemplateAnswers).countConclusions !== undefined &&
                        JSON.parse(result.saveddata[0].TemplateAnswers).countConclusions > 0) {
                        this.setState({
                            countConclusions: JSON.parse(result.saveddata[0].TemplateAnswers).countConclusions,
                        });
                    } else {
                        this.setState({
                            countConclusions: 1,
                        });
                    }

                    if (JSON.parse(result.saveddata[0].TemplateAnswers).countLessonsLearnt !== undefined &&
                        JSON.parse(result.saveddata[0].TemplateAnswers).countLessonsLearnt > 0) {
                        this.setState({
                            countLessonsLearnt: JSON.parse(result.saveddata[0].TemplateAnswers).countLessonsLearnt,
                        });
                    } else {
                        this.setState({
                            countLessonsLearnt: 1,
                        });
                    }
                }
            });

        this.props.propUpdatePageLoadData(this.state.pageLoadData);
    }

    checkIfChecked = (element, value) => {
        if (element === value) {
            return true;
        } else {
            return false;
        }
    };

    incrementConclusions = () => {
        var countConclusions = this.state.countConclusions;

        if (countConclusions < 10) {
            countConclusions += 1;
        }

        this.setState({ countConclusions: countConclusions });
    }

    incrementLessonsLearnt = () => {
        var countLessonsLearnt = this.state.countLessonsLearnt;

        if (countLessonsLearnt < 10) {
            countLessonsLearnt += 1;
        }

        this.setState({ countLessonsLearnt: countLessonsLearnt });
    }

    render() {
        let {
            trim,
            trimOnSubmit,
            pageLoadData,
            countConclusions,
            countLessonsLearnt
        } = this.state;
        return (
            <Grid container>
                <AutoForm
                    onSubmit={this._onSubmit}
                    onChange={this._onChange}
                    trim={!!trim}
                    trimOnSubmit={!!trimOnSubmit}
                    style={{ width: "100%" }}
                >
                    <Grid item xs={12}>
                        <p>Scoring</p>
                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Relevance</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmrS1Relevance" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmrS1Relevance, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmrS1Relevance, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmrS1Relevance, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Efficiency</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmrS2Efficiency" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmrS2Efficiency, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmrS2Efficiency, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmrS2Efficiency, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Effectiveness</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmrS3Effectiveness" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmrS3Effectiveness, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmrS3Effectiveness, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmrS3Effectiveness, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Impact</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmrS4Impact" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmrS4Impact, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmrS4Impact, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmrS4Impact, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Sustainability</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmrS5Sustainability" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmrS5Sustainability, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmrS5Sustainability, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmrS5Sustainability, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>



                        <br />
                        <p>Project Snopsis</p>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Context</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ1Context" rows={6} defaultValue={this.state.pageLoadData.EmrQ1Context} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>Description of the Intervention Logic </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ2Description" rows={6} defaultValue={this.state.pageLoadData.EmrQ2Description} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <p>Findings</p>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>Relevance </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ3Relevance" rows={6} defaultValue={this.state.pageLoadData.EmrQ3Relevance} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>Efficiency</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ4Efficiency" rows={6} defaultValue={this.state.pageLoadData.EmrQ4Efficiency} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>Effectiveness</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ5Effectiveness" rows={6} defaultValue={this.state.pageLoadData.EmrQ5Effectiveness} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>Impact </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ6Impact" rows={6} defaultValue={this.state.pageLoadData.EmrQ6Impact} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>Sustainability </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ7Sustainability" rows={6} defaultValue={this.state.pageLoadData.EmrQ7Sustainability} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>


                        <br />
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>Conclusion</Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails style={{ display: countConclusions > 0 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ8ConclusionC1" rows={6}
                                        style={{ width: "100%", display: countConclusions > 0 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ8ConclusionC1} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countConclusions > 1 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ8ConclusionC2" rows={6}
                                        style={{ width: "100%", display: countConclusions > 1 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ8ConclusionC2} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countConclusions > 2 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ8ConclusionC3" rows={6}
                                        style={{ width: "100%", display: countConclusions > 2 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ8ConclusionC3} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countConclusions > 3 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ8ConclusionC4" rows={6}
                                        style={{ width: "100%", display: countConclusions > 3 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ8ConclusionC4} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countConclusions > 4 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ8ConclusionC5" rows={6}
                                        style={{ width: "100%", display: countConclusions > 4 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ8ConclusionC5} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countConclusions > 5 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ8ConclusionC6" rows={6}
                                        style={{ width: "100%", display: countConclusions > 5 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ8ConclusionC6} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countConclusions > 6 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ8ConclusionC7" rows={6}
                                        style={{ width: "100%", display: countConclusions > 6 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ8ConclusionC7} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countConclusions > 7 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ8ConclusionC8" rows={6}
                                        style={{ width: "100%", display: countConclusions > 7 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ8ConclusionC8} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countConclusions > 8 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ8ConclusionC9" rows={6}
                                        style={{ width: "100%", display: countConclusions > 8 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ8ConclusionC9} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countConclusions > 9 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ8ConclusionC10" rows={6}
                                        style={{ width: "100%", display: countConclusions > 9 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ8ConclusionC10} />
                                </Grid>
                            </ExpansionPanelDetails>

                            <ExpansionPanelDetails>
                                <Grid item xs>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.incrementConclusions.bind(this)}
                                    >
                                        Add Conclusion
                                </Button>
                                </Grid>
                            </ExpansionPanelDetails>

                        </ExpansionPanel>

                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>Lessons Learnt</Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails style={{ display: countLessonsLearnt > 0 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ10Lesson" rows={6}
                                        style={{ width: "100%", display: countLessonsLearnt > 0 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ10Lesson} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countLessonsLearnt > 1 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ11Lesson2" rows={6}
                                        style={{ width: "100%", display: countLessonsLearnt > 1 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ11Lesson2} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countLessonsLearnt > 2 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ12Lesson3" rows={6}
                                        style={{ width: "100%", display: countLessonsLearnt > 2 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ12Lesson3} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countLessonsLearnt > 3 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ13Lesson4" rows={6}
                                        style={{ width: "100%", display: countLessonsLearnt > 3 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ13Lesson4} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countLessonsLearnt > 4 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ14Lesson5" rows={6}
                                        style={{ width: "100%", display: countLessonsLearnt > 4 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ14Lesson5} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countLessonsLearnt > 5 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ15Lesson6" rows={6}
                                        style={{ width: "100%", display: countLessonsLearnt > 5 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ15Lesson6} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countLessonsLearnt > 6 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ16Lesson7" rows={6}
                                        style={{ width: "100%", display: countLessonsLearnt > 6 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ16Lesson7} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countLessonsLearnt > 7 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ17Lesson8" rows={6}
                                        style={{ width: "100%", display: countLessonsLearnt > 7 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ17Lesson8} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countLessonsLearnt > 8 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ19Lesson9" rows={6}
                                        style={{ width: "100%", display: countLessonsLearnt > 8 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ19Lesson9} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countLessonsLearnt > 9 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmrQ20Lesson10" rows={6}
                                        style={{ width: "100%", display: countLessonsLearnt > 9 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmrQ20Lesson10} />
                                </Grid>
                            </ExpansionPanelDetails>

                            <ExpansionPanelDetails>
                                <Grid item xs>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.incrementLessonsLearnt.bind(this)}
                                    >
                                        Add Lessons Learnt
                                </Button>
                                </Grid>
                            </ExpansionPanelDetails>

                        </ExpansionPanel>
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }} className="mt-1">
                        <Button variant="contained" color="primary" type="submit">
                            SAVE
            </Button>
                    </Grid>
                </AutoForm>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/E_Mr.js